import { getSettingLoggedInCatnavFullWidthXP } from "@faire/retailer/settings/getSettingLoggedInCatnavFullWidthXP";
import { useIsBestsellers } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsBestsellers";
import { useIsHubCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsHubCategory";

export const useEnableFullWidthCatnavXP = () => {
  const { isHubCategory } = useIsHubCategory();
  const { isBestsellers } = useIsBestsellers();

  return (
    (!isHubCategory || isBestsellers) && getSettingLoggedInCatnavFullWidthXP()
  );
};
